import React, { useState } from 'react'
import { Edit,Trash } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { StoreType } from '../../../types/modules/admin/storeType.type'
import { Link } from 'react-router-dom'
import UpdateStoreTypeForm from './UpdateStoreTypeForm'
import { useUpdateResource } from '../../../hooks/useUpdateResource'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    type:StoreType
}

function StoreTypeItem({type}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = type.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = type.languages.find(s=>s.languageCode==="ar")?.name ||"";

        const {updateResource} = useUpdateResource();
        async function handleDelete(){
            await  updateResource(`type/${type.id}`, {},"admin",{
                method: "DELETE",
                successMessage: t("deleted_success"),
                invalidateQueries:["store-types-by-admin"],
                confirmMessage:t("confirm_delete")
            });
        }

  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatNumber(type.id)}
        </td>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        <img src={type.iconUrl} alt={enName} className='w-14 h-14 object-contain'/>
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {arName}
        </td>

        <PermissionGate permissions={[PermissionsKey.ViewTypeOfStore]}>
            <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
                <Link to={`/admin/subTypes/${type.id}`} className=' underline capitalize'>
                {t('view')}
                </Link>
            </td>
        </PermissionGate>

        <td className="p-3 min-w-[200px] text-Black font-normal  flex gap-2">
        <PermissionGate permissions={[PermissionsKey.UpdateTypeOfStore]}>
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
        </PermissionGate>
        <PermissionGate permissions={[PermissionsKey.DeleteTypeOfStore]}>
            <button onClick={handleDelete} className=' text-Red'>
                <Trash/>
            </button>
        </PermissionGate>
        </td>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateStoreTypeForm
        id={type.id}
        defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        cover={type.iconUrl}
        onSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default StoreTypeItem